export interface JobStatus {
    jobid: string;
    status: JobStatusEnum;
    errorMessage: string;
}

export enum JobStatusEnum {
    NotFound = "NotFound",
    Submitted = "Submitted",
    Running = "Running",
    Completed = "Completed",
    Failed = "Failed"
}